import React from "react";
import { Box } from "../../assets/ui";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  StyledDescriptionWrapper,
  StyledDesktopSliderControllers,
  StyledSliderWrapper,
  StyledSliderContent
} from "./ui";
import { StyledImageWrapper } from "../../components/StepSlider/ui";

const sliderContent = [
  {
    img: "Section 2 -1.png",
    title: "Find opponents and partners",
    description:
      "Our platform allows you to search, compare and invite other players/partners/opponents.  Found your match?  Agree the terms and split the cost. Book and pay the venues directly through Exsportia. "
  },
  {
    img: "Section 2 -2.png",
    title: "Tournaments, Teams and League",
    description:
      "Create, Join and manage. Build your team with other players on the network, join or create leagues and tournaments. Manage everything in one place, completely automated."
  },
  {
    img: "Section 2 -4.png",
    title: "Invitation Center",
    description:
      "Send and receive invitations for sports and activities you play. Manage multiple invitations simultaneously. Set your availability so you Get the invitations that match your availability."
  },
  {
    img: "Section 2 -3.png",
    title: "“Sprofile®” by Exsportia",
    description:
      "Create your sport profile “Sprofile” and let others know what sports you play and at what level. Set your calendar and availability to start playing the sports and activities you love. Add pictures, Video and more to attract the right opponents and partners. Manage your account and payment options, see your analytics and monitor your performances. Be your own manager."
  }
];

class SliderSimple extends React.Component {
  state = {
    nav1: null,
    nav2: null,
    currentSlide: 0,
    autoplay: true
  };

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }

  onUserSelectSlide = index => {
    this.slider2.slickGoTo(index);
    this.setState({ autoplay: false });
  };

  render() {
    const { currentSlide } = this.state;

    const settings1 = {
      dots: false,
      focusOnSelect: false,
      arrows: false,
      className: "center",
      centerMode: true,
      centerPadding: "13px",
      speed: 500,
      slidesToShow: 1,
      infinite: true,
      adaptiveHeight: true,

      onSwipe: () => {
        this.setState({ autoplay: false });
      },

      beforeChange: (current, next) => {
        this.setState({ currentSlide: next });
      },

      responsive: [
        {
          breakpoint: 639,
          settings: {
            slidesPerRow: 1,
            slidesToShow: 1
          }
        },
        {
          breakpoint: 5000,
          settings: {
            vertical: true,
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    const settings2 = {
      dots: false,
      focusOnSelect: false,
      arrows: false,
      speed: 500,
      slidesToShow: 1,
      infinite: true,
      adaptiveHeight: true,
      autoplay: this.state.autoplay,
      autoplaySpeed: 3000,
      onSwipe: () => {
        this.setState({ autoplay: false });
      },

      responsive: [
        {
          breakpoint: 639,
          settings: {
            slidesPerRow: 1,
            slidesToShow: 1
          }
        }
      ]
    };

    return (
      <StyledSliderWrapper>
        <StyledSliderContent>
          <StyledDesktopSliderControllers>
            {sliderContent.map((el, index) => {
              return (
                <StyledDescriptionWrapper
                  display={["none", "block"]}
                  active={index === currentSlide}
                  key={index}
                  onClick={() => this.onUserSelectSlide(index)}
                >
                  <h3>{el.title}</h3>
                  <p>{el.description}</p>
                </StyledDescriptionWrapper>
              );
            })}
          </StyledDesktopSliderControllers>

          <Box paddingTop={["0", "40px"]}>
            <StyledImageWrapper margin={["0", null, null, "0 auto"]}>
              <div className="img-wrapper">
                <div className="phone-content">
                  <div className="phone-header"></div>
                  <Slider
                    asNavFor={this.state.nav2}
                    ref={slider => (this.slider1 = slider)}
                    {...settings2}
                  >
                    {sliderContent.map((el, index) => {
                      return (
                        <img src={`./images/${el.img}`} alt="" key={index} />
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </StyledImageWrapper>
          </Box>

          <Box display={["block", "none"]}>
            <Slider
              asNavFor={this.state.nav1}
              ref={slider => (this.slider2 = slider)}
              {...settings1}
            >
              {sliderContent.map((el, index) => {
                return (
                  <Box padding={["40px 8px 25px"]} key={index}>
                    <StyledDescriptionWrapper display={["block", "none"]}>
                      <h3>{el.title}</h3>
                      <p>{el.description}</p>
                    </StyledDescriptionWrapper>
                  </Box>
                );
              })}
            </Slider>
          </Box>
        </StyledSliderContent>
      </StyledSliderWrapper>
    );
  }
}

export default SliderSimple;
